<template>
<div>
  <el-radio-group v-model="chioseType" @change="setType">
    <el-radio-button
        :label="item.type"
        v-for="item in orgTypes"
        :key="item.type"
    >{{ item.name }}
    </el-radio-button
    >
  </el-radio-group>
</div>
</template>

<script>
import {orgTypes} from "@/tools/utils";

export default {
name: "typeTab",
  props:{
    types:{
      type:Number
    }
  },
  data(){
  return{
    chioseType:'',
    orgTypes: orgTypes(),
  }
  },
  created() {
    this.chioseType = this.types
  },
  methods:{
    setType(val) {
      if (val === 2) {
        this.$router.replace('/projectOffice/organizationAdd2')
      } else if (val === 3) {
        this.$router.replace('/projectOffice/organizationAdd3')
      } else if (val === 4) {
        this.$router.replace('/projectOffice/organizationAdd4')
      } else if (val === 5) {
        this.$router.replace('/projectOffice/organizationAdd5')
      } else if (val === 6) {
        this.$router.replace('/projectOffice/organizationAdd6')
      }
    },
  }
}
</script>

<style scoped lang="scss">

</style>